(function () {
  var STORAGE_KEY = "checkout_prefill_data";

  init();
  bindCtaClose();

  function init() {
    var data = consumeQueryPrefill() || readPrefill();
    if (!data || data.show_pre_approved_banner !== true) return;

    whenModalReady(function (modal) {
      applyPrefill(modal, data);
      data.show_pre_approved_banner = false;
      writePrefill(data);
      modal.show();
    });
  }

  function consumeQueryPrefill() {
    var params = new URLSearchParams(window.location.search);
    var encoded = params.get("prefill_data");
    if (!encoded) return null;

    try {
      var data = decodeBase64Json(encoded);
      if (!data || typeof data !== "object") return null;
      writePrefill(data);
      stripPrefillParam();
      return data;
    } catch (error) {
      console.warn("Invalid prefill_data query param", error);
      return null;
    }
  }

  function readPrefill() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writePrefill(data) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  function decodeBase64Json(encoded) {
    var normalized = String(encoded)
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    var pad = normalized.length % 4;
    if (pad) normalized += "=".repeat(4 - pad);

    var binary = atob(normalized);
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return JSON.parse(new TextDecoder().decode(bytes));
  }

  function stripPrefillParam() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has("prefill_data")) return;
    url.searchParams.delete("prefill_data");
    var next = url.pathname + url.search + url.hash;
    window.history.replaceState({}, "", next);
  }

  function bindCtaClose() {
    whenModalReady(function (modal) {
      var cta = modal.querySelector(".pre-approved-modal__cta");
      if (!cta || cta.dataset.boundClose) return;
      cta.dataset.boundClose = "true";
      cta.addEventListener("click", function () {
        if (typeof modal.hide === "function") modal.hide();
      });
    });
  }

  function whenModalReady(callback) {
    var run = function () {
      var modal = document.getElementById("PreApprovedModal");
      if (modal && typeof modal.show === "function") callback(modal);
    };

    if (window.customElements && customElements.get("modal-dialog")) {
      run();
      return;
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined("modal-dialog").then(run);
      return;
    }
    run();
  }

  function applyPrefill(modal, data) {
    var greetingEl = modal.querySelector("[data-pre-approved-greeting]");
    var amountEl = modal.querySelector("[data-pre-approved-amount]");
    var name = firstName(data.name);

    if (greetingEl) {
      var template =
        modal.getAttribute("data-greeting-template") || "Hi __NAME__,";
      var generic =
        modal.getAttribute("data-greeting-generic") || "Hi,";
      greetingEl.textContent = name
        ? template.replace("__NAME__", name)
        : generic;
    }

    if (amountEl && data.approved_limit != null && data.approved_limit !== "") {
      var rupees = Number(data.approved_limit);
      if (!isNaN(rupees)) amountEl.textContent = formatApprovedLimit(rupees);
    }
  }

  function firstName(name) {
    if (!name || typeof name !== "string") return "";
    return name.trim().split(/\s+/)[0] || "";
  }

  function formatApprovedLimit(rupees) {
    var cents = Math.round(rupees * 100);
    if (typeof formatMoney === "function") {
      return String(
        formatMoney(cents, (window.theme && window.theme.moneyFormat) || "")
      ).replace(/\.00(?!\d)/, "");
    }
    return "₹" + Math.round(rupees).toLocaleString("en-IN");
  }
})();
